const actions = {
  FETCH_ROOMS_BEGIN: "MESSENGER_FETCH_ROOMS_BEGIN",
  FETCH_ROOMS_SUCCESS: "MESSENGER_FETCH_ROOMS_SUCCESS",
  FETCH_ROOMS_ERR: "MESSENGER_FETCH_ROOMS_ERR",

  SELECT_ROOM: "MESSENGER_SELECT_ROOM",

  FETCH_MESSAGES_BEGIN: "MESSENGER_FETCH_MESSAGES_BEGIN",
  FETCH_MESSAGES_SUCCESS: "MESSENGER_FETCH_MESSAGES_SUCCESS",
  FETCH_MESSAGES_ERR: "MESSENGER_FETCH_MESSAGES_ERR",

  APPEND_MESSAGE: "MESSENGER_APPEND_MESSAGE",

  SEND_MESSAGE_BEGIN: "MESSENGER_SEND_MESSAGE_BEGIN",
  SEND_MESSAGE_SUCCESS: "MESSENGER_SEND_MESSAGE_SUCCESS",
  SEND_MESSAGE_ERR: "MESSENGER_SEND_MESSAGE_ERR",

  fetchRoomsBegin: () => ({ type: actions.FETCH_ROOMS_BEGIN }),
  fetchRoomsSuccess: (data) => ({ type: actions.FETCH_ROOMS_SUCCESS, data }),
  fetchRoomsErr: (err) => ({ type: actions.FETCH_ROOMS_ERR, err }),

  selectRoom: (room) => ({ type: actions.SELECT_ROOM, room }),

  fetchMessagesBegin: () => ({ type: actions.FETCH_MESSAGES_BEGIN }),
  fetchMessagesSuccess: (data) => ({ type: actions.FETCH_MESSAGES_SUCCESS, data }),
  fetchMessagesErr: (err) => ({ type: actions.FETCH_MESSAGES_ERR, err }),

  appendMessage: (message) => ({ type: actions.APPEND_MESSAGE, message }),

  sendMessageBegin: () => ({ type: actions.SEND_MESSAGE_BEGIN }),
  sendMessageSuccess: () => ({ type: actions.SEND_MESSAGE_SUCCESS }),
  sendMessageErr: (err) => ({ type: actions.SEND_MESSAGE_ERR, err }),
};

export default actions;
